import { useEffect, useRef } from "react";
import style from "./MyBottomSheet.module.scss";
import Hammer from 'hammerjs';

//const MyBottomSheet = ({ display=true, header, content, cbY=()=>{}, percentY = [0.1, 0.4, 0.85],defalutYIndex=1 }) => {
const MyBottomSheet = ({ zIndex=99,display=true, header, content, cbY=()=>{}, percentY = [0, 0.4, 0.85],defalutYIndex=0 ,canDrag=true}) => {
    const bottomRef = useRef(null);
    const tempTopRef = useRef(0);
    const lastTopRef = useRef(0);
    const bottomCurrentPos = useRef(0);
    const diffDistance = 0.05;
    useEffect(() => {
        if(canDrag===false)return;
        const element = bottomRef.current;
        //init
        const newY = document.body.clientHeight * percentY[defalutYIndex];
        lastTopRef.current = newY;
        tempTopRef.current = newY;
        bottomCurrentPos.current=percentY[defalutYIndex];
        bottomRef.current.style.bottom = `${-newY}px`;
        //init end
        const onTouchEnd = () => {
            bottomRef.current.style.transition = 'bottom .2s ease-out';
            const yPercent = tempTopRef.current / bottomRef.current.clientHeight;
            const direct = tempTopRef.current > lastTopRef.current ? "down" : "up";
            const isMove = Math.abs(yPercent - bottomCurrentPos.current) > diffDistance;
            if (isMove) {
                if (direct === "up") {
                    const index = percentY.indexOf(bottomCurrentPos.current);
                    if (index > 0) {
                        bottomCurrentPos.current = percentY[index - 1];
                    }
                }
                else if (direct === "down") {
                    const index = percentY.indexOf(bottomCurrentPos.current);
                    if (index < percentY.length - 1) {
                        bottomCurrentPos.current = percentY[index + 1];
                    }
                }
            }
            console.log("bottomCurrentPos.current",bottomCurrentPos.current)
            const newY = bottomRef.current.clientHeight * bottomCurrentPos.current;
            bottomRef.current.style.bottom = `${-newY}px`;
            lastTopRef.current = newY;
            tempTopRef.current = newY;
        };

        bottomRef.current.addEventListener('pointerup', onTouchEnd);

        const hammer = new Hammer(bottomRef.current);
        hammer.get('pan').set({ direction: Hammer.DIRECTION_VERTICAL });

        const onPan = (e) => {
            if (e.isFinal) return;
            tempTopRef.current = lastTopRef.current + e.deltaY;
            if (tempTopRef.current < document.body.clientHeight*percentY[0])
                tempTopRef.current = document.body.clientHeight*percentY[0];
            bottomRef.current.style.bottom = `${-tempTopRef.current}px`;
        };
        hammer.on('pan', onPan);

        const onPanStart = () => {
            bottomRef.current.style.transition = '';
        };
        hammer.on('panstart', onPanStart);

        const onPanEnd = () => {
            if (bottomRef.current.style.transition === "")
                onTouchEnd();
        };
        hammer.on('panend', onPanEnd);

        const observer = new MutationObserver(() => {
            const topValue = parseFloat(bottomRef.current?.style.bottom || 0); // 取得數值形式的 top
            const screenHeight = bottomRef.current.clientHeight; // 畫面高度
            const percentage = (topValue / screenHeight) * 100; // 計算百分比
            cbY(parseInt(percentage*-1));
        });


        observer.observe(bottomRef.current, {
            attributes: true, // 監控屬性變化
            attributeFilter: ['style'], // 只關注 style 屬性
        });

        // 清理函数，移除事件监听器
        return () => {
            element.removeEventListener('pointerup', onTouchEnd);
            hammer.off('pan', onPan);
            hammer.off('panstart', onPanStart);
            hammer.off('panend', onPanEnd);
            observer.disconnect();
        };
    }, []);

    return (
        <div ref={bottomRef} className={`${style.bottomModal} ${display ? "" : style.hidden}`}
        style={{zIndex:`${zIndex}`}}>
            <div className={style.header}>{header}</div>
            {content}
        </div>
    );
};

export default MyBottomSheet;
